module.exports = __webpack_public_path__ + "static/media/recipe.9dc71c93.png";